import { render, staticRenderFns } from "./BackofficeDiagnostico.vue?vue&type=template&id=5e5aad4f"
import script from "./BackofficeDiagnostico.vue?vue&type=script&lang=ts"
export * from "./BackofficeDiagnostico.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports